import { isResponseSuccessful } from "@onestore/onestore-store-common/http"
import type { Store } from "@reduxjs/toolkit"
import { uniq } from "lodash"
import Storage from "~/lib/storage"
import type { AppState } from "../reducer"
import { getFlatBasketItems } from "./selectors"

export default function basketSubscriber(store: Store<AppState>): void {
  store.subscribe(() => {
    const state = store.getState()

    if (isResponseSuccessful(state.basket.request_state)) {
      Storage.setDomainsCount(state.basket.domains.length)
      const basketItems = uniq(
        getFlatBasketItems(state)
          .map((item): string => `${item.plan_id}`)
          .filter((item): boolean => !!item)
      )

      Storage.setBasketProducts(basketItems)
    }
  })
}
